/**
 * `lib/fteWords.ts` — #2933: an FTE in words for the People List.
 *
 * 1.0 reads "Full time". Less reads "0.6 · part time", the number first.
 * The row shows the number bold and the words muted, so `fteParts` hands
 * the two pieces apart; `fteWords` joins them.
 *
 * Pure: no React.
 */

export interface FteParts {
  /** The number ("0.6"), or `null` for full time. */
  value: string | null;
  /** "Full time", "part time" or "above full time". */
  words: string;
}

/** "0.6" from 0.6, "0.75" from 0.75: at most two decimals, at least one. */
function fteNumber(fte: number): string {
  const rounded = Math.round(fte * 100) / 100;
  return Number.isInteger(rounded) ? rounded.toFixed(1) : String(rounded);
}

export function fteParts(fte: number | null | undefined): FteParts {
  if (fte === null || fte === undefined || !Number.isFinite(fte)) return { value: "—", words: "" };
  if (Math.abs(fte - 1) < 0.005) return { value: null, words: "Full time" };
  if (fte > 1) return { value: fteNumber(fte), words: "above full time" };
  return { value: fteNumber(fte), words: "part time" };
}

/** "Full time", "0.6 · part time". */
export function fteWords(fte: number | null | undefined): string {
  const { value, words } = fteParts(fte);
  if (value === null) return words;
  return words ? `${value} · ${words}` : value;
}
